import { Link } from "react-router-dom";
import Logo from "@/components/Logo";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="bg-[#1E1610] text-[#F4F1EA]">
      <div className="mx-auto max-w-7xl px-4 py-16 sm:px-8 lg:px-16">
        <div className="grid gap-12 md:grid-cols-3">
          <div>
            <Logo light />
            <p className="mt-6 max-w-sm font-serif text-xl italic leading-relaxed text-[#F4F1EA]/70">
              A historic courtyard estate, reimagined. Gather, reset and reconnect among the dog fields.
            </p>
          </div>
          <div>
            <p className="font-mono text-xs uppercase tracking-[0.25em] text-[#C89D56]">Explore</p>
            <ul className="mt-5 space-y-3">
              {[
                { to: "/estate", label: "The Estate & Cottages", testid: "footer-link-estate" },
                { to: "/weddings", label: "Weddings", testid: "footer-link-weddings" },
                { to: "/retreats", label: "Retreats", testid: "footer-link-retreats" },
                { to: "/gallery", label: "Gallery", testid: "footer-link-gallery" },
                { to: "/enquire", label: "Enquire", testid: "footer-link-enquire" },
              ].map((l) => (
                <li key={l.to}>
                  <Link to={l.to} data-testid={l.testid} className="text-sm text-[#F4F1EA]/70 transition-colors hover:text-[#C89D56]">
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
          <div>
            <p className="font-mono text-xs uppercase tracking-[0.25em] text-[#C89D56]">Find us</p>
            <p className="mt-5 text-sm leading-relaxed text-[#F4F1EA]/70">
              Plas Llechylched
              <br />
              Rhosneigr, Isle of Anglesey
              <br />
              North Wales
            </p>
          </div>
        </div>
        <div className="mt-14 flex flex-col items-start justify-between gap-4 border-t border-[#F4F1EA]/10 pt-8 sm:flex-row sm:items-center">
          <p className="font-mono text-[11px] uppercase tracking-[0.2em] text-[#F4F1EA]/40">
            © {new Date().getFullYear()} Plas Llechylched
          </p>
          <p className="font-mono text-[11px] uppercase tracking-[0.2em] text-[#F4F1EA]/40">
            Roamed by the FERAL Mowers
          </p>
        </div>
      </div>
    </footer>
  );
}
